import React from 'react';
import { Image, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import styles from './CategoryCard.module.scss';

export interface CategoryData {
  id: number;
  name: string;
  description?: string;
  templates_count?: number;
  template_count?: number;
  img_path?: string;
}

interface CategoryCardProps {
  category: CategoryData;
  onViewTemplates: (categoryId: number) => void;
}

const FALLBACK_ICON = 'https://placehold.co/56x56';

export const CategoryCard: React.FC<CategoryCardProps> = ({
  category,
  onViewTemplates
}) => {
  const { t } = useTranslation();
  const count = category.templates_count ?? category.template_count ?? 0;

  const handleCardClick = () => {
    onViewTemplates(category.id);
  };

  return (
    <div className={styles.cardContainer}>
      <div className={styles.contentWrapper}>
        <div className={styles.bannerWrapper}>
          <div className={styles.avatarBadge}>
            <Image
              className={styles.avatarImage}
              src={category.img_path || FALLBACK_ICON}
              fallback={FALLBACK_ICON}
              alt={category.name}
              preview={false}
            />
          </div>
        </div>

        <div className={styles.badgeWrapper}>
          <div className={styles.templatesCountBadge}>
            <span className={styles.badgeText}>
              {count} {count === 1 ? t('phishingTemplateManager.template') : t('phishingTemplateManager.templates')}
            </span>
          </div>
        </div>

        <div className={styles.textSection}>
          <div className={styles.categoryTitle}>{category.name}</div>
          <div className={styles.categoryDescription}>
            {category.description || t('phishingTemplateManager.categoryDefaultDescription')}
          </div>
        </div>
      </div>

      <div className={styles.footerWrapper}>
        <Button
          type="primary"
          onClick={handleCardClick}
          className={styles.viewButton}
        >
          <span className={styles.buttonText}>
            {t('phishingTemplateManager.viewTemplates')}
          </span>
        </Button>
      </div>
    </div>
  );
};

export default CategoryCard;